export default __webpack_public_path__ + "static/media/t.c374e689.obj";